import PropTypes from 'prop-types';
/* PropTypes */

export const SurveyDashboardPropTypes = {
  datasheets: PropTypes.array.isRequired,
  job: PropTypes.object.isRequired,
  isPublic: false
};

export const SurveyStatisticsPropTypes = {
  surveySummary: PropTypes.object.isRequired,
};

